import { TeamDomainQueryModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const TeamQueryShapeSchema = TeamDomainQueryModelSchema

export type TeamQueryShape = ZodInfer<typeof TeamQueryShapeSchema>
